import React from "react";

const ProfileAvatar = ({ user }) => {

    if (!user) return null;

    // If image exists
    if (user.profileImage) {
        return (
            <img
                src={user.profileImage}
                alt="Profile"
                className="profile-avatar-img"
            />
        );
    }

    // Otherwise show initials
    const getInitials = () => {
        const names = user.name.split(" ");
        return names.length >= 2
            ? names[0][0] + names[1][0]
            : names[0][0];
    };

    return (
        <div className="profile-avatar-initials">
            {getInitials().toUpperCase()}
        </div>
    );
};

export default ProfileAvatar;
